import React, {useState} from "react";
import {Card, Modal} from "antd";
import dayjs from 'dayjs';
import CdnImage from "../CdnImage";

const UpdateCard = ({update, children}) => {
    const [previewOpen, setPreviewOpen] = useState(false);

    return (
        <Card style={{height: '100%'}} className={"text-center"} key={update.id}>
            <h2>{update.title}</h2>
            <p>{(update.posted_at && dayjs(update.posted_at).fromNow())}</p>
            <div style={{cursor: 'pointer'}} onClick={() => setPreviewOpen(true)}>
                <CdnImage src={update.image} width={500} height={500} style={{
                    borderRadius: '10px',
                    width: '100%',
                    height: '250px',
                    objectFit: 'cover',
                    objectPosition: 'center'
                }}/>
            </div>
            <Modal
                open={previewOpen}
                onCancel={() => setPreviewOpen(false)}
                footer={null}
                width={800}
                centered
            >
                <CdnImage src={update.image} width={1200} height={1200} style={{
                    width: '100%',
                    height: 'auto',
                    borderRadius: '10px',
                    objectFit: 'contain'
                }}/>
            </Modal>
            <p className={"mar-t-1"}>{update.description.split('\n').map((l, i) => {
                return <span key={i}>{l}<br/></span>
            })}</p>
            {children}
        </Card>
    )
}

export default UpdateCard;